export default class Gallery {
    constructor(element) {
        this.element = element;
        this.initializeDOM();

        if(this.thumbs.length > 0) {
            this.showLarge(this.thumbs[0]);
        }
    }

    initializeDOM() {
        this.large = this.element.querySelector(".gallery__large img");

        if(!this.large) {
            throw "No large view in DOM";
        }

        this.large.addEventListener("load", () => {
            this.element.classList.remove("loading");
        })

        this.thumbs = this.element.querySelectorAll(".gallery__thumbs li img");

        this.thumbs.forEach((image) => {
            image.addEventListener("click", () => {
                this.showLarge(image);
            });
        });
    }

    showLarge(thumb) {
        this.large.src = thumb.getAttribute("data-large");
        this.large.alt = thumb.alt;

        this.thumbs.forEach((image) => {
            image.parentElement.classList.remove("active");
        });

        thumb.parentElement.classList.add("active");

        this.element.classList.add("loading");
    }
}